import Link from "next/link";
import {Box, Typography} from "@mui/material";
import {formatDate} from "../date/formatDate";
import {StripeContent} from "~/app/components/stripe/stripe";
import {PressPost} from "~/features/press/model";

type Props = {
  post: PressPost;
};

export function PressListItem({post}: Props) {
  return (
    <StripeContent
      key={post.id}
      sx={{
        borderTop: "solid 1px #ddd",
        "&:hover": {
          backgroundColor: "#efefef",
        },
      }}>
      <Box
        component="article"
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "240px 1fr",
          },
          gap: 3,
          py: 4,
        }}
      >
        {post.image && (
          <Box
            component="img"
            src={post.image}
            alt=""
            sx={{
              width: "100%",
              height: 220,
              objectFit: "cover",
              borderRadius: 2,
            }}
          />
        )}

        <Box>
          {/* Meta */}
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              mb: 1,
              fontSize: "0.85rem",
              color: "text.secondary",
              textTransform: "uppercase",
            }}
          >
            <Typography variant="body2">{post.source}</Typography>
            <Typography variant="body2">•</Typography>
            <Typography variant="body2">
              <time dateTime={post.publishedAt}>
                {formatDate(post.publishedAt)}
              </time>
            </Typography>
          </Box>

          {/* Titel */}
          <Typography
            variant="h4"
            component="h2"
            sx={{mb: 1}}
          >
            {post.title}
          </Typography>

          {/* Excerpt */}
          <Typography
            variant="body1"
            sx={{
              mb: 2,
              maxWidth: "70ch",
            }}
          >
            {post.excerpt}
          </Typography>

          {/* Link */}
          <Link href={`/press/${post.slug}`}>
            weiter lesen…
          </Link>
        </Box>
      </Box>
    </StripeContent>
  );
}
